// src/components/onboarding/screens/TransmissionScreen.js
import React, { useState, useEffect } from 'react';

const TransmissionScreen = ({ onComplete, error }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const duration = 3500;
    const startTime = Date.now();

    const animate = () => {
      const elapsed = Date.now() - startTime;
      const newProgress = Math.min(elapsed / duration, 1);
      setProgress(newProgress);

      if (newProgress < 1) {
        requestAnimationFrame(animate);
      } else {
        setTimeout(onComplete, 300);
      }
    };

    requestAnimationFrame(animate);
  }, [onComplete]);

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <div className="bg-gray-800 w-full max-w-md rounded-3xl overflow-hidden border border-white/10 shadow-2xl shadow-black/50 p-6 flex flex-col items-center justify-center text-center min-h-[500px]">
        <div className="relative mb-10">
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-emerald-500/30 animate-pulse"
              style={{
                width: `${80 + i * 30}px`,
                height: `${80 + i * 30}px`,
                opacity: 1 - i * 0.3,
                animationDelay: `${i * 0.3}s`
              }}
            />
          ))}
          <div className="w-20 h-20 bg-gradient-to-br from-emerald-300 to-emerald-600 rounded-full flex items-center justify-center shadow-lg shadow-emerald-500/40 relative z-10">
            <span className="text-white text-4xl font-bold rounded-full">
              <video 
                className="w-full h-full object-cover rounded-full"
                autoPlay 
                loop 
                muted 
                playsInline
              >
                <source src="/assets/lux-video-new.mp4" type="video/mp4" />
                Votre navigateur ne supporte pas la lecture de vidéos.
              </video>
            </span>
          </div>
        </div>

        <div className="w-48 mb-6">
          <div className="h-1.5 bg-gray-700 rounded overflow-hidden">
            <div
              className="h-full bg-gradient-to-r from-emerald-300 to-emerald-600 rounded transition-all"
              style={{ width: `${progress * 100}%` }}
            />
          </div>
        </div>

        <p className="text-gray-200 text-base font-medium mb-2">
          {progress < 0.5 ? "Envoi de tes réponses..." : "Lux prépare ton accueil..."}
        </p>
        <p className="text-gray-500 text-sm">
          Lux, c'est ton coach dans l'app
        </p>

        {error && (
          <p className="text-red-400 text-sm mt-4">{error}</p>
        )}
      </div>
    </div>
  );
};

export default TransmissionScreen;
